export const num2name = {
    0: "ERROR_UNSPECIFIED",
    1: "ERROR_SELF_LEARNING_HIERARCHY_NOT_FOUND",
    2: "ERROR_CONDITIONS_TO_BE_READY_NOT_SATISFIED",
};
export const name2num = {
    ERROR_UNSPECIFIED: 0,
    ERROR_SELF_LEARNING_HIERARCHY_NOT_FOUND: 1,
    ERROR_CONDITIONS_TO_BE_READY_NOT_SATISFIED: 2,
};
